import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
const SvgIconNavigationLowerRank = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M11.4227 16.4219L10.2441 15.2434L13.8216 11.666L10.2441 8.08854L11.4227 6.91003L16.1786 11.666L11.4227 16.4219Z",
		fill: "#C0C0C0"
	}), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M4.16602 3.33301H5.83268V10.833H14.9993V12.4997H4.16602V3.33301Z",
		fill: "#C0C0C0"
	})]
});
export default SvgIconNavigationLowerRank;
